var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-accordion-item text-truncate py-1",on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.addressString)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }